module.exports = __webpack_public_path__ + "img/2_2025_04_24.62954f6d.jpg";